import { render, staticRenderFns } from "./vPoliticaPrivacidade.vue?vue&type=template&id=0ab77426&scoped=true"
import script from "./vPoliticaPrivacidade.vue?vue&type=script&lang=js"
export * from "./vPoliticaPrivacidade.vue?vue&type=script&lang=js"
import style0 from "./vPoliticaPrivacidade.vue?vue&type=style&index=0&id=0ab77426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab77426",
  null
  
)

export default component.exports